import { logError } from "../../utils/logger";

export const validateField = (required, value, setErrorMsg, onValidate, matcher, submit, setSubmit, requiredErrorMsg, formatErrorMsg, onErrorAnalytics = ()=>{}) => {
    if (submit) {
        if (required && !value?.trim()) {
            setTimeout(()=>setErrorMsg(requiredErrorMsg),0);
            onErrorAnalytics(requiredErrorMsg);
            onValidate(false);
            setSubmit(false);
            return false;
        } else if (value?.trim()) {
            if (!matcher(value)) {
                setTimeout(()=>setErrorMsg(formatErrorMsg),0);
                onErrorAnalytics(formatErrorMsg);
                onValidate(false);
                setSubmit(false);
                return false;
              } else {
                setErrorMsg('');
                onValidate(true);
                return true;
              }
        }
    }
};

export const validateNameField = (required, value, setErrorMsg, onValidate, matcher, submit, setSubmit, requiredErrorMsg, formatErrorMsg, onErrorAnalytics = ()=>{}, isLastNameField) => {
    const inputVal = value?.trim();
    if (submit) {
        const timeout = isLastNameField ? 0:300
        if (required && !inputVal) {
            //adding this extra check for accessibility purpose making sure the first name error is read last all the fields are having error
            setTimeout(()=>setErrorMsg(requiredErrorMsg),timeout);
            onErrorAnalytics(requiredErrorMsg);
            onValidate(false);
            setSubmit(false);
            return false;
        } else if (inputVal) {
            if (!matcher(inputVal)) {
                //adding this extra check for accessibility purpose making sure the first name error is read last all the fields are having error
                setTimeout(()=>setErrorMsg(formatErrorMsg),timeout);
                setErrorMsg(formatErrorMsg)
                onErrorAnalytics(formatErrorMsg);
                onValidate(false);
                setSubmit(false);
                return false;
              } else {
                setErrorMsg('');
                onValidate(true);
                return true;
              }
        }
    }
};

export const getCurrentInputField = (isValid, inputField, currentField) => {
    try {
        if (!isValid && inputField && !inputField?.current) {
            inputField.current = currentField.current;
        }
    } catch (error) {
        logError(error, false, 'getCurrentInputField', [currentField]);
    }
};